﻿document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('EMTV')) {
        initMenu();
    }
});

const initMenu = (listener) => {
    const $menuElement = document.getElementById('mainmenu');
    const $hamburgers = document.querySelectorAll('.header .hamburger');
    const $html = document.documentElement;

    if ($hamburgers.length) {
        $hamburgers.forEach($hamburger => {
            let $target = document.getElementById($hamburger.dataset.target);
            let closeTxt = $hamburger.dataset.close;
            let $label = $hamburger.querySelector('.hamburger-label');
            let openTxt = $label.innerHTML;
            $hamburger.dataset.open = openTxt;
            $hamburger.addEventListener('click', (event) => {
                $target.classList.toggle('is-active');
                $hamburger.classList.toggle('is-active');
                $html.classList.toggle('menu-open');
                if ($label !== null) {
                    if ($label.innerHTML === openTxt) {
                        $label.innerHTML = closeTxt;
                    } else {
                        $label.innerHTML = openTxt;
                    }
                }
            });
        });

        window.addEventListener('resize', (event) => {
            $hamburgers.forEach($hamburger => {
                let $target = document.getElementById($hamburger.dataset.target);
                let $label = $hamburger.querySelector('.hamburger-label');
                $hamburger.classList.remove('is-active');
                $target.classList.remove('is-active');
                $html.classList.remove('menu-open');
                if ($label !== null) {
                    $label.innerHTML = $hamburger.dataset.open;
                }
            });
        });
        
        document.addEventListener('click', (event) => {
            let isClickInside = false;
            $hamburgers.forEach($hamburger => {
                let $target = document.getElementById($hamburger.dataset.target);
                let $label = $hamburger.querySelector('.hamburger-label');
                if ($target.contains(event.target) || $hamburger.contains(event.target)) {
                    isClickInside = true;
                }

                if (!isClickInside) {
                    $hamburger.classList.remove('is-active');
                    $target.classList.remove('is-active');
                    $html.classList.remove('menu-open');
                    if ($label !== null) {
                        $label.innerHTML = $hamburger.dataset.open;
                    }
                }
            });
        });
    }

    if (typeof $menuElement !== 'undefined') {
        const $drillLinks = [...$menuElement.querySelectorAll('.mainmenu-drilldownlink')];
        const $backLinks = [...$menuElement.querySelectorAll('.mainmenu-backlink')];
        const $icons = [...$menuElement.querySelectorAll('.mainmenu-dropdownlink .icon')];

        $drillLinks.forEach(drillLink => {
            drillLink.addEventListener('click', (event) => {
                let $targetMenu = drillLink.nextSibling.nextSibling;
                $targetMenu.classList.add('active');
            }, false);
        });

        $backLinks.forEach(backLink => {
            backLink.addEventListener('click', (event) => {
                let $targetMenu = event.target.closest('.mainmenu-child');
                $targetMenu.classList.remove('active');
            }, false);
        });

        $icons.forEach(icon => {
            icon.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                event.target.closest('a').classList.toggle('active');
                let $targetMenu = event.target.closest('li').querySelector('.mainmenu-child');
                $targetMenu.classList.toggle('active');
            }, false);
        });
    }
}

export { initMenu };
